export enum OrderSide {
  Exchange = 'exchange',
  Target = 'target'
}
